import React from 'react';
import ReactDom from 'react-dom';
import Search from './search/index.jsx'

const SearchInit = () => {
  if ( document.getElementById('js-searchWrapper') ) {
    ReactDom.render(<Search/>, document.getElementById('js-searchWrapper'));
  }
}

SearchInit()